import { Link } from 'gatsby';
import { Button, Text } from 'theme-ui';
import SVG from 'react-inlinesvg';

const styles = {
  button: (block) => ({
    lineHeight: 1.6,
    fontWeight: 'bolder',
    height: 'auto',
    width: 'max-content',
    maxWidth: '85%',
    minWidth: [200, 300, 500],
    borderColor: 'transparent',
    backgroundColor: 'transparent !important',
    '::after': {
      backgroundColor: '#fb4c68',
      border: '#fb4c68',
      borderRadius: '10px',
      boxShadow: '0 14px 28px rgba(0,0,0,0.25),0 10px 10px rgba(0,0,0,0.1)',
    },
    svg: {
      fill: 'white',
      ...(!block ? { marginLeft: 10 } : { marginTop: 10 }),
    },
    ':hover': {
      transform: 'translateY(-10%)',
      color: 'white !important',
      borderColor: 'transparent',
      '::after': {
        boxShadow: '0px 30px 40px 0px rgba(0,0,0,0.2)',
      },
    },
    ...(block && { flexDirection: 'column' }),
  }),
};
type Props = {
  text: string;
  link?: string;
  style?: any;
  icon?: any;
  type?: string;
};
const StyledButton = ({ text, style, link, icon, type }: Props) => {
  return (
    <Button
      sx={{
        ...styles.button(type === 'block'),
        ...style,
      }}
      as={Link}
      to={link}
    >
      <Text
        sx={{
          overflow: 'hidden',
        }}
      >
        {text}
      </Text>
      {icon && <SVG src={icon.src} />}
    </Button>
  );
};
export default StyledButton;
